import React from "react";

const PartnerLogosSlider = () => {
  const partnersRow1 = [
    { name: "Delta State", logo: "/images/partner/delta state.jpg" },
    { name: "Ekiti State", logo: "/images/partner/Ekiti State.jpg" },
    { name: "Ondo State", logo: "/images/partner/Ondo State.png" },
    { name: "Edo State", logo: "/images/partner/Seal_of_Edo_State.png" }
  ];

  return (
    <section className="w-full bg-white py-8 md:py-20 overflow-hidden">
      <style>{`
        @keyframes marqueeLeft {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        @keyframes marqueeRight {
          0% {
            transform: translateX(-50%);
          }
          100% {
            transform: translateX(0);
          }
        }

        .animate-marquee-left {
          display: flex;
          width: max-content;
          animation: marqueeLeft 35s linear infinite;
        }

        .animate-marquee-right {
          display: flex;
          width: max-content;
          animation: marqueeRight 35s linear infinite;
        }

        .animate-marquee-left:hover,
        .animate-marquee-right:hover {
          animation-play-state: paused;
        }

        @media (min-width: 768px) {
          .animate-marquee-left,
          .animate-marquee-right {
            animation-duration: 45s;
          }
        }
      `}</style>

      {/* Heading */}
      <div className="container mx-auto px-4 md:px-6 mb-8 md:mb-12 text-center">
        <div className="w-16 md:w-20 h-1 bg-green-600 mx-auto rounded-full mb-3 md:mb-4"></div>

        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900">
          Trusted by Our Partners
        </h2>

        <p className="mt-2 md:mt-3 text-sm md:text-base text-gray-600 max-w-2xl mx-auto px-2">
          We collaborate with leading organizations and businesses to deliver
          innovative and reliable solutions.
        </p>
      </div>

      <div className="relative overflow-hidden w-full">
        {/* Top Row */}
        <div>
          <div className="animate-marquee-left items-center gap-6 sm:gap-10 md:gap-16 px-3 sm:px-5">
            {[...partnersRow1, ...partnersRow1].map((partner, index) => (
              <div
                key={`row1-${index}`}
                className="
                  flex
                  items-center
                  justify-center
                  min-w-[160px]
                  sm:min-w-[200px]
                  md:min-w-[240px]
                  h-24
                  sm:h-28
                  md:h-32
                  bg-white
                  rounded-xl
                  sm:rounded-2xl
                  shadow-sm
                  transition-all
                  px-4
                "
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  loading="lazy"
                  decoding="async"
                  className="
                    max-h-12
                    sm:max-h-16
                    md:max-h-20
                    max-w-[120px]
                    sm:max-w-[150px]
                    md:max-w-[180px]
                    w-auto
                    object-contain
                    transition-transform
                    duration-300
                  "
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartnerLogosSlider;